var Handlebars = require('/home/circleci/project/node_modules/handlebars/lib/index.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers['if'].call(depth0, depth0, {"name":"if","hash":{},"fn":this.program(2, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"2":function(depth0,helpers,partials,data) {
  var helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, lambda=this.lambda;
  return "        <div class=\"poll-text-answer\"><span class=\"poll-text-answer-index\">"
    + escapeExpression(((helpers.addOne || (depth0 && depth0.addOne) || helperMissing).call(depth0, (data && data.index), {"name":"addOne","hash":{},"data":data})))
    + ".</span>"
    + escapeExpression(lambda(depth0, depth0))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1;
  stack1 = helpers.each.call(depth0, ((stack1 = (depth0 != null ? depth0.results : depth0)) != null ? stack1.textResults : stack1), {"name":"each","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { return stack1; }
  else { return ''; }
  },"useData":true});